<template>
  <div class="turtlecat-runner w-100 pl-5 pt-5 h-100">
    <Toast />
    <div ref="runnerLayout" class="turtlecat-layout d-flex w-100 p-0 h-100">
      <div
        class="turtlecat-sidebar p-0 d-flex flex-column justify-content-between py-5 px-3 h-100"
        :class="{ 'turtlecat-panel-hidden': !toggleMenuLeft }"
        :style="{ width: sidebarWidth + 'px' }"
      >
        <div
          class="w-100 d-flex flex-column justify-content-between"
          style="min-height: 100%"
        >
          <div>
            <div>
              <div class="d-flex flex-column">
                <label for="">Conta</label>
                <Dropdown
                  v-model="contaSelecionada"
                  :options="contas"
                  optionLabel="label"
                  optionValue="id"
                  placeholder="Sistema"
                  appendTo="body"
                  class="w-100"
                  @change="onContaChange"
                  filter
                />
              </div>
              <div class="d-flex flex-column mt-3" id="sistema-licenciada">
                <label for="">Sistema licenciada</label>
                <Dropdown
                  v-model="sistemaLicenciadaSelecionado"
                  :options="sistemaLicenciada"
                  optionLabel="sli_titulo"
                  optionValue="sistema_licenciada_id"
                  placeholder="Sistema"
                  appendTo="body"
                  class="w-100"
                  @change="onLicenciadaChange"
                  filter
                />
              </div>
              <div class="d-flex flex-column mt-3" id="modelo">
                <label for="">Modelo</label>
                <Dropdown
                  v-model="modeloSelecionado"
                  :options="modelos"
                  optionLabel="md_descricao"
                  optionValue="modelo_id"
                  placeholder="Modelo"
                  class="w-100"
                  @change="onModeloChange"
                  appendTo="body"
                  filter
                />
              </div>
            </div>
            <div
              v-if="isApiGenerica && modeloSelecionado"
              class="d-flex flex-column mt-3"
            >
              <label>Parâmetros da API (JSON)</label>
              <VueJSONEditor
                class="turtlecat-parametros-editor"
                :content="parametrosApiContent"
                :onChange="onParametrosApiChange"
                mode="text"
                :mainMenuBar="false"
                :navigationBar="false"
                :statusBar="false"
                style="width: 100%; height: 320px; min-width: 0"
              />
              <small class="text-muted">
                Preencha os valores exigidos pelo modelo, como datas e unidade.
              </small>
            </div>
            <div class="mt-3">
              <!-- <Tree :value="treeData"></Tree> -->
              <v-treeview
                v-if="this.sistemaLicenciadaItem.bat_sql_bancos"
                :items="treeData"
                activatable
                dense
                item-key="name"
                :load-children="carregarConfigDB"
                open-on-click
                transition
                style="height: 350px; width: 100%; overflow-x: auto"
              >
                <template v-slot:prepend="{ item }">
                  <v-icon>
                    {{ item.icon }}
                  </v-icon>
                </template>
                <template v-slot:label="{ item }">
                  <span
                    class="font-weight-bold d-flex align-items-center"
                    :title="item.name"
                    @contextmenu.prevent="copiarNomeTabela($event, item.name)"
                  >
                    {{ item.name }}
                    <i
                      v-if="
                        item.data &&
                        item.data.item &&
                        item.data.item.tipo &&
                        item.data.item.sql_da_estrutura &&
                        item.data.item.tipo == 'VIEW'
                      "
                      class="fa-solid fa-eye ml-2"
                      @click="
                        exibirSqlView($event, item.data.item.sql_da_estrutura)
                      "
                      title="Copiar SQL de criação da VIEW"
                    ></i
                  ></span>
                </template>
              </v-treeview>
              <button
                v-if="nodePendente"
                class="btn btn-warning btn-sm mt-3"
                @click="carregarConfigDB(nodePendente)"
              >
                <i
                  v-if="loadingTree"
                  class="fa-solid fa-spinner fa-spin mr-2"
                ></i>
                Buscar resposta
              </button>
            </div>
          </div>

          <div>
            <div class="mt-15" v-if="historicoFiltrado.length">
              <div
                v-b-toggle.collapse-1
                @click="historicoAberto = !historicoAberto"
                class="d-flex align-items-center"
              >
                <i
                  class="fa-solid mr-3"
                  :class="{
                    'fa-caret-right': !historicoAberto,
                    'fa-caret-down': historicoAberto
                  }"
                ></i
                >Histórico local
              </div>
              <b-collapse id="collapse-1" class="mt-2">
                <div style="max-height: 200px; overflow-y: auto">
                  <div
                    v-for="item in historicoFiltrado"
                    :key="item.data + item.sql"
                    class="sql-item cursor-pointer ml-6"
                    :title="item.sql"
                    @click="restaurarHistorico(item)"
                  >
                    {{ item.sql }}
                  </div>
                </div>
              </b-collapse>
            </div>
            <label for="" class="mr-3">Limite</label>
            <Dropdown
              v-model="limit"
              :options="[
                { label: 'Sem limite', value: -1 },
                { label: '10 linhas', value: 10 },
                { label: '30 linhas', value: 30 },
                { label: '50 linhas', value: 50 },
                { label: '100 linhas', value: 100 },
                { label: '500 linhas', value: 500 },
                { label: '1000 linhas', value: 1000 }
              ]"
              optionLabel="label"
              optionValue="value"
              placeholder="Limite de linhas"
              appendTo="body"
            />
          </div>
        </div>
      </div>
      <div
        class="turtlecat-divider turtlecat-divider-vertical"
        role="separator"
        aria-label="Ajustar largura da lateral"
        aria-orientation="vertical"
        :aria-valuenow="Math.round(sidebarPosition)"
        title="Arraste para ajustar; dê dois cliques para restaurar"
        tabindex="0"
        @pointerdown="startResize($event, 'sidebar')"
        @pointermove="moveResize"
        @pointerup="stopResize"
        @pointercancel="stopResize"
        @lostpointercapture="stopResize"
        @keydown.left.prevent="resizeSidebar(sidebarPosition - 20)"
        @keydown.right.prevent="resizeSidebar(sidebarPosition + 20)"
        @dblclick="restoreSidebar"
        @keydown.enter.prevent="restoreSidebar"
      ></div>
      <div id="container-editor" class="turtlecat-main p-0 d-flex flex-column">
        <div ref="workspace" class="turtlecat-workspace">
          <div
            v-show="toggleEditor"
            class="turtlecat-code"
            :style="{
              flex: resultsCollapsed ? '1 1 0%' : '0 0 ' + editorHeight + '%'
            }"
          >
            <MonacoEditor
              v-show="enabledQuery"
              ref="monacoEditor"
              class="w-100 h-100"
              @sql="updateSql"
            />
            <div v-if="!enabledQuery" class="w-100">
              <p class="text-center">Selecione uma conta e um sistema</p>
            </div>
          </div>
          <div
            class="turtlecat-divider turtlecat-divider-horizontal"
            role="separator"
            aria-label="Ajustar altura do código e da tabela"
            aria-orientation="horizontal"
            :aria-valuenow="Math.round(editorPosition)"
            aria-valuemin="0"
            aria-valuemax="100"
            title="Arraste para ajustar; dê dois cliques para restaurar"
            tabindex="0"
            @pointerdown="startResize($event, 'editor')"
            @pointermove="moveResize"
            @pointerup="stopResize"
            @pointercancel="stopResize"
            @lostpointercapture="stopResize"
            @keydown.up.prevent="resizeEditor(editorPosition - 5)"
            @keydown.down.prevent="resizeEditor(editorPosition + 5)"
            @dblclick="restoreEditor"
            @keydown.enter.prevent="restoreEditor"
          ></div>
          <div v-show="!resultsCollapsed" class="turtlecat-results">
            <div class="d-flex mb-3 ml-3 pr-3 w-100 justify-content-between">
              <button
                class="btn btn-success btn-sm"
                :class="{
                  'spinner spinner-left spinner-white pl-15':
                    queryLoading || queryLoadingResposta
                }"
                :disabled="
                  queryLoading || queryLoadingResposta || !enabledButton
                "
                @click="executarQuery"
              >
                <i
                  class="flaticon2-arrow"
                  v-if="!queryLoading && !queryLoadingResposta"
                ></i>
                Executar Query
              </button>
              <button
                v-if="lastHashRequestFailed"
                class="btn btn-warning btn-sm mr-3"
                :title="lastHashRequestFailed"
                :disabled="queryLoading || queryLoadingResposta"
                @click="respostaQuery(lastHashRequestFailed)"
              >
                Buscar resposta
              </button>
            </div>
            <div class="turtlecat-table" style="border-top: 1px solid #e9ecef">
              <Message
                :life="60000"
                severity="error"
                v-if="error"
                :sticky="false"
                @close="error = null"
                >{{ error }}</Message
              >
              <DataTable
                :value="linhas"
                showGridlines
                responsiveLayout="scroll"
                :resizableColumns="true"
                ref="dt"
                columnResizeMode="expand"
                scrollHeight="flex"
                :scrollable="true"
                filterDisplay="menu"
                stripedRows
                class="p-datatable-sm w-100"
                :class="{ 'pui-datatable': colunas.length }"
                autoLayout
                :filters.sync="filters1"
                :globalFilterFields="globalFilterFields"
                :loading="queryLoading || queryLoadingResposta"
              >
                <template #header>
                  <div class="d-flex justify-content-between">
                    <Button
                      icon="pi pi-external-link"
                      label="Exportar"
                      class="p-button-outlined"
                      @click="$refs.dt.exportCSV()"
                    />
                    <div>
                      <Button
                        type="button"
                        icon="pi pi-filter-slash"
                        label="Limpar"
                        class="p-button-outlined mr-3"
                        @click="clearFilter1"
                      />
                      <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText
                          v-model="filters1['global'].value"
                          placeholder="Pesquisar..."
                        />
                      </span>
                    </div>
                  </div>
                </template>

                <template #empty>Sem dados para exibir.</template>
                <template #loading
                  >Carregando dados. Por favor, aguarde.</template
                >

                <Column
                  v-if="colunas.length"
                  header=" "
                  frozen
                  :bodyStyle="{ 'text-align': 'center' }"
                  :headerStyle="{ 'text-align': 'center' }"
                >
                  <template #body="slotProps">
                    <div class="d-flex justify-content-center w-100">
                      {{ slotProps.index + 1 }}
                    </div>
                  </template>
                </Column>

                <Column
                  v-for="col in colunas"
                  :key="col.field"
                  :field="col.field"
                  sortable
                  :filterField="col.field"
                >
                  <template #header>
                    <div
                      @contextmenu.prevent="copyColumnName(col.header)"
                      class="cursor-pointer"
                      title="Copiar nome da coluna"
                    >
                      {{ col.header }}
                    </div>
                  </template>
                  <template v-slot:filter="{ filterModel }">
                    <InputText
                      type="text"
                      v-model="filterModel.value"
                      class="p-column-filter"
                      :placeholder="'Filtrar por ' + col.header"
                    />
                  </template>
                  <template #body="slotProps">
                    <span
                      :class="{
                        'turtlecat-null': slotProps.data[col.field] === '[NULL]'
                      }"
                    >
                      {{ slotProps.data[col.field] }}
                    </span>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonacoEditor from "./MonacoEditor.vue";
import VueJSONEditor from "../../licenciada/components/VueJSONEditor.vue";
import Dropdown from "primevue/dropdown";
import DataTable from "primevue/datatable";
import Tree from "primevue/tree";
import Column from "primevue/column";
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import sqlRunnerService from "@/core/services/sql-runner.service.js";
import Message from "primevue/message";
import { mapGetters } from "vuex";
import Toast from "primevue/toast";

export default {
  name: "SQLRunner",
  components: {
    MonacoEditor,
    VueJSONEditor,
    Dropdown,
    DataTable,
    Column,
    InputText,
    Button,
    Message,
    Toast
  },
  data() {
    return {
      sql: "",
      contas: [],
      contaSelecionada: null,
      sistemaLicenciada: [],
      sistemaLicenciadaSelecionado: null,
      modelos: [],
      modeloSelecionado: null,
      parametrosApiContent: { json: {} },
      queryLoading: false,
      queryLoadingResposta: false,
      linhas: [],
      colunas: [],
      filters1: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      globalFilterFields: [],
      error: null,
      log: "",
      historico: [],
      historicoAberto: false,
      toggleMenuLeft: true,
      toggleEditor: true,
      sidebarWidth: 300,
      editorHeight: 40,
      resultsCollapsed: false,
      resizeDrag: null,
      limit: 50, // Limite padrão de linhas
      lastHashRequestFailed: "",
      treeData: [
        {
          name: "Carregar configurações...",
          children: [],
          type: "start"
        }
      ],
      nodePendente: null,
      loadingTree: false
    };
  },
  mounted() {
    this.contas = this.contasParaTroca.map((conta) => ({
      ...conta,
      label: `${conta.id} - ${conta.login} ${
        conta.nome ? "(" + conta.nome + ")" : ""
      }`
    }));
    this.contas.push({
      id: this.currentUserPersonalInfo.conta_id,
      label:
        this.currentUserPersonalInfo.conta_id +
        " - " +
        this.currentUserPersonalInfo.conta
    });
    const historicoLocal = localStorage.getItem("sqlRunnerHistorico");
    if (historicoLocal) {
      try {
        this.historico = JSON.parse(historicoLocal);
      } catch (e) {
        console.error("Erro ao carregar histórico do localStorage", e);
      }
    }

    if (this.currentUserPersonalInfo.conta_id) {
      this.contaSelecionada = this.currentUserPersonalInfo.conta_id;
      this.onContaChange();
    }

    window.addEventListener("keydown", (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "r") {
        e.preventDefault();
        this.executarQuery();
      }
    });
  },
  computed: {
    ...mapGetters(["contasParaTroca", "currentUserPersonalInfo"]),
    sidebarPosition() {
      if (!this.toggleMenuLeft) return 0;
      return this.sidebarWidth;
    },
    editorPosition() {
      return !this.toggleEditor
        ? 0
        : this.resultsCollapsed
        ? 100
        : this.editorHeight;
    },
    parametrosApi: {
      get() {
        return typeof this.parametrosApiContent.text === "string"
          ? this.parametrosApiContent.text
          : JSON.stringify(this.parametrosApiContent.json, null, 2);
      },
      set(text) {
        this.parametrosApiContent = { text };
      }
    },
    historicoFiltrado() {
      return this.historico.filter(
        (i) =>
          i.conta === this.contaSelecionada &&
          i.sistemaLicenciada === this.sistemaLicenciadaSelecionado
      );
    },
    enabledQuery() {
      return this.sistemaLicenciada.some((i) => {
        return (
          i.sistema_licenciada_id === this.sistemaLicenciadaSelecionado &&
          !["API_E", "WHK"].includes(i.banco_id)
        );
      });
    },
    enabledButton() {
      return (
        this.contaSelecionada &&
        this.sistemaLicenciadaSelecionado &&
        this.enabledQuery &&
        (!this.isApiGenerica || this.modeloSelecionado)
      );
    },
    isApiGenerica() {
      return this.sistemaLicenciadaItem.banco_id === "API_G";
    },
    sistemaLicenciadaItem() {
      const q = this.sistemaLicenciada?.find(
        (i) => i.sistema_licenciada_id === this.sistemaLicenciadaSelecionado
      );
      return q ?? {};
    }
  },
  methods: {
    resizeSidebar(width) {
      const available = this.$refs.runnerLayout.clientWidth;
      this.toggleMenuLeft = width > 80;
      if (!this.toggleMenuLeft) return;
      this.sidebarWidth = Math.max(160, Math.min(width, 400, available - 200));
    },
    resizeEditor(height) {
      this.toggleEditor = height > 8;
      this.resultsCollapsed = this.toggleEditor && height >= 92;
      if (!this.toggleEditor || this.resultsCollapsed) return;
      this.editorHeight = Math.max(15, Math.min(height, 80));
    },
    restoreSidebar() {
      this.toggleMenuLeft = true;
      this.resizeSidebar(this.sidebarWidth);
    },
    restoreEditor() {
      this.toggleEditor = true;
      this.resultsCollapsed = false;
    },
    startResize(event, axis) {
      if (event.button !== 0) return;
      event.preventDefault();
      this.resizeDrag = {
        axis,
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        size: axis === "sidebar" ? this.sidebarPosition : this.editorPosition
      };
      event.currentTarget.setPointerCapture(event.pointerId);
    },
    moveResize(event) {
      const drag = this.resizeDrag;
      if (!drag || event.pointerId !== drag.pointerId) return;
      if (drag.axis === "sidebar") {
        this.resizeSidebar(drag.size + event.clientX - drag.x);
      } else {
        const height = this.$refs.workspace.clientHeight;
        if (height)
          this.resizeEditor(
            drag.size + ((event.clientY - drag.y) * 100) / height
          );
      }
    },
    stopResize(event) {
      if (this.resizeDrag?.pointerId === event.pointerId)
        this.resizeDrag = null;
    },
    onParametrosApiChange(content) {
      this.parametrosApiContent = content;
    },
    exibirSqlView(event, sql) {
      event.stopPropagation();
      // this.$refs.monacoEditor.setQuery(sql);
      this.copiarAreaTransferencia(sql);
    },
    copiarNomeTabela(event, coluna) {
      event.stopPropagation();
      this.copiarAreaTransferencia(coluna);
    },
    copiarAreaTransferencia(texto) {
      navigator.clipboard
        .writeText(texto)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Copiado para área de transferência",
            life: 3000
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao copiar para área de transferência",
            life: 3000
          });
        });
    },
    handleChange(val, event) {
      this.$emit("update:value", val);
    },
    onContaChange() {
      if (!this.contaSelecionada) return;
      this.sistemaLicenciadaSelecionado = null;
      this.sistemaLicenciada = [];
      this.resetModelo();
      this.resetTreeData();
      sqlRunnerService
        .getLicenciadasPorConta(this.contaSelecionada)
        .then((response) => {
          this.sistemaLicenciada = response.data;
        });
    },
    onLicenciadaChange() {
      if (!this.sistemaLicenciadaSelecionado) return;
      this.resetModelo();
      this.resetTreeData();
      sqlRunnerService
        .getModeloPorSisLicenciada(this.sistemaLicenciadaSelecionado)
        .then((response) => {
          this.modelos = response.data;
        });
    },
    onModeloChange() {
      if (!this.modeloSelecionado) return;
      const modelo = this.modelos.find(
        (modelo) => modelo.modelo_id === this.modeloSelecionado
      );
      this.sql = modelo ? modelo.md_consulta : "";
      try {
        const parametros = modelo && modelo.api_parametros;
        this.parametrosApi = JSON.stringify(
          typeof parametros === "string"
            ? JSON.parse(parametros)
            : parametros || {},
          null,
          2
        );
      } catch (error) {
        this.parametrosApi = "{}";
        this.error =
          "Os parâmetros cadastrados no modelo não contêm um JSON válido.";
      }
      this.$refs.monacoEditor.setQuery(this.sql);
    },
    resetModelo() {
      this.modelos = [];
      this.modeloSelecionado = null;
      this.parametrosApi = "{}";
      this.sql = "";
      this.linhas = [];
      this.colunas = [];
      this.error = null;
      this.lastHashRequestFailed = "";
      if (this.$refs.monacoEditor) this.$refs.monacoEditor.setQuery("");
    },
    mensagemErro(erro, padrao) {
      if (typeof erro === "string") return erro;
      return erro?.data || erro?.error || erro?.message || padrao;
    },
    executarQuery() {
      if (
        !this.sql ||
        !this.enabledButton ||
        this.queryLoading ||
        this.queryLoadingResposta
      ) {
        return;
      }
      let dadosModelo = {};
      if (this.isApiGenerica) {
        try {
          const parametros = JSON.parse(this.parametrosApi);
          if (
            !parametros ||
            typeof parametros !== "object" ||
            Array.isArray(parametros)
          ) {
            throw new Error("Parâmetros inválidos");
          }
          dadosModelo = { modelo_id: this.modeloSelecionado, parametros };
        } catch (error) {
          this.error =
            "Preencha os parâmetros da API com um objeto JSON válido.";
          return;
        }
      }
      this.error = null;
      this.lastHashRequestFailed = "";
      const bancoId = this.sistemaLicenciada.find(
        (i) => i.sistema_licenciada_id === this.sistemaLicenciadaSelecionado
      ).banco_id;
      const queryFormatada = this.formatarConsultaPorBanco(this.sql, bancoId);
      const historicoItem = {
        sql: this.sql,
        data: new Date(),
        conta: this.contaSelecionada,
        sistemaLicenciada: this.sistemaLicenciadaSelecionado,
        modelo: this.modeloSelecionado,
        ...(this.isApiGenerica ? { parametrosApi: this.parametrosApi } : {})
      };

      this.queryLoading = true;
      const sistemaLicenciadaId = this.sistemaLicenciadaSelecionado;
      this.linhas = [];
      this.colunas = [];
      this.logger("Solicitando a execução da query...");
      sqlRunnerService
        .execQuery(
          this.sistemaLicenciadaSelecionado,
          queryFormatada,
          { showOverlay: false },
          dadosModelo
        )
        .then((response) => {
          if (this.sistemaLicenciadaSelecionado !== sistemaLicenciadaId) return;
          this.logger("Query executada com sucesso. Aguardando resposta...");
          if (!response.data.sucesso) {
            this.error = response.data.error;
            return;
          }
          this.salvarHistorico(historicoItem);
          this.respostaQuery(response.data.uid);
        })
        .catch((error) => {
          const dados = error.response?.data;
          this.error = this.mensagemErro(
            dados?.requisicao?.requisicao?.resultado || dados,
            "Erro ao executar a query."
          );
        })
        .finally(() => {
          this.queryLoading = false;
        });
    },
    respostaQuery(uid) {
      if (!uid || this.queryLoadingResposta) return;
      const sistemaLicenciadaId = this.sistemaLicenciadaSelecionado;
      this.lastHashRequestFailed = uid;
      this.error = null;
      this.queryLoadingResposta = true;
      sqlRunnerService
        .respostaQuery(sistemaLicenciadaId, uid, {
          showOverlay: false
        })
        .then((response) => {
          if (this.sistemaLicenciadaSelecionado !== sistemaLicenciadaId) return;
          if (!response.data.requisicao.sucesso) {
            this.error = response.data.requisicao.error;
            return;
          }
          if (response.data.requisicao.requisicao.status !== "FINALIZADO") {
            this.error =
              "A consulta ainda está sendo processada. Por favor, aguarde alguns instantes e tente novamente.";
            return;
          }
          this.lastHashRequestFailed = "";
          if (response.data.requisicao.requisicao.sucesso_requisicao) {
            this.linhas = response.data.requisicao.requisicao.resultado;
            this.formatarDadosTabela();
          } else {
            this.error = this.mensagemErro(
              response.data.requisicao.requisicao.resultado,
              "Erro ao executar a query."
            );
          }
        })
        .catch((error) => {
          if (this.sistemaLicenciadaSelecionado !== sistemaLicenciadaId) return;
          this.error = this.mensagemErro(
            error.response?.data,
            "Erro ao buscar a resposta da consulta."
          );
        })
        .finally(() => {
          this.queryLoadingResposta = false;
        });
    },
    updateSql(val) {
      this.sql = val;
    },
    formatarDadosTabela() {
      this.colunas = Object.keys(this.linhas[0] || {}).map((key) => ({
        field: key,
        header: key,
        sortable: true
      }));

      if (this.colunas.some((c) => c == "")) {
        this.error =
          "A consulta retornou colunas sem nome. Verifique a consulta SQL.";
      }

      this.filters1 = {
        global: { value: null, matchMode: "contains" }
      };

      this.colunas.forEach((col) => {
        this.filters1[col.field] = {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        };
      });

      this.linhas.forEach((obj) => {
        Object.keys(obj).forEach((chave) => {
          if (obj[chave] === null || obj[chave] === undefined) {
            obj[chave] = "[NULL]";
          }
        });
      });

      this.globalFilterFields = this.colunas.map((col) => col.field);
    },
    clearFilter1() {
      Object.keys(this.filters1).forEach((key) => {
        this.filters1[key].value = null;
      });
    },
    logger(message, life = -1) {
      this.log = message;
      if (life > 0) {
        setTimeout(() => {
          this.log = "";
        }, life);
      }
    },
    restaurarHistorico(item) {
      if (this.isApiGenerica) {
        if (!this.modelos.some((modelo) => modelo.modelo_id === item.modelo)) {
          this.error = "O modelo desta consulta não está mais disponível.";
          return;
        }
        this.modeloSelecionado = item.modelo;
        this.onModeloChange();
        if (typeof item.parametrosApi === "string") {
          this.parametrosApi = item.parametrosApi;
        }
      }
      this.$refs.monacoEditor.setQuery(item.sql);
    },
    salvarHistorico(novoItem) {
      if (
        this.historico.some(
          (item) =>
            item.sql === novoItem.sql &&
            item.conta === novoItem.conta &&
            item.sistemaLicenciada === novoItem.sistemaLicenciada &&
            (typeof novoItem.parametrosApi !== "string" ||
              (item.modelo === novoItem.modelo &&
                item.parametrosApi === novoItem.parametrosApi))
        )
      ) {
        return;
      }
      this.historico.unshift(novoItem);
      this.historico = this.historico.slice(0, 50);
      localStorage.setItem(
        "sqlRunnerHistorico",
        JSON.stringify(this.historico)
      );
    },
    formatarConsultaPorBanco(consulta, bancoId) {
      consulta = consulta.trim().replace(/;$/, ""); // remove ; final

      // Aplica apenas se começar com SELECT
      if (!/^select\s/i.test(consulta)) {
        return consulta;
      }

      if (this.limit < 0) {
        return consulta;
      }

      const limitador = this.limit;
      let formatado = "";
      let limit = "";

      switch (bancoId) {
        case "FIR": // Firebird
          limit = `FIRST ${limitador}`;
          formatado = `SELECT ${limit} * FROM ( ${consulta} ) res`;
          break;

        case "SAP": // MaxDB/SAPDB
          limit = `AND ROWNO <= ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res WHERE (1=1 ${limit})`;
          break;

        case "MSS": // SQL Server
        case "IRIS": // Intersystems IRIS
          limit = `TOP ${limitador}`;
          formatado = `SELECT ${limit} * FROM ( ${consulta} ) res`;
          break;

        case "ORA": // Oracle
          limit = `AND ROWNUM <= ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res WHERE (1=1 ${limit})`;
          break;

        case "MYS": // MySQL
          limit = `LIMIT ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res ${limit}`;
          break;

        case "POS": // PostgreSQL
          limit = `LIMIT ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res ${limit}`;
          break;

        case "API_G": // API Genérica
          limit = `LIMIT ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res ${limit}`;
          break;

        default:
          formatado = consulta;
      }

      return formatado;
    },
    resizeend(e1, e2) {
      console.log("Resize ended", e1, e2);
    },
    async carregarConfigDB(node) {
      this.loadingTree = true;
      if (node.type == "start") {
        await this.carregarDB(node);
      }
      if (node.type == "database") {
        await this.carregarEsquemas(node);
      }
      if (node.type == "schema") {
        await this.carregarTabelas(node);
      }
      if (node.type == "table") {
        await this.carregarColunas(node);
      }
      this.loadingTree = false;
    },
    async carregarDB(node) {
      const q = this.sistemaLicenciadaItem.bat_sql_bancos;
      const resultado = await this.consultaQuery(q, node);
      const array = !resultado
        ? []
        : resultado.map((item) => {
            return {
              name: item.banco_de_dados,
              icon: "mdi-database",
              children: [],
              type: "database"
            };
          });
      this.treeData = array;
    },
    async carregarEsquemas(node) {
      let q = this.sistemaLicenciadaItem.bat_sql_esquemas;
      if (!q) {
        node.type = "schema";
        node.data = {
          banco: node.name
        };
        return;
      }
      q = q.replace("{banco}", node.name);
      const resultado = await this.consultaQuery(q, node);
      const array = !resultado
        ? []
        : resultado.map((item) => {
            return {
              name: item.esquema,
              icon: "mdi-folder-outline",
              children: [],
              type: "schema",
              data: {
                banco: node.name
              }
            };
          });
      node.children = array;
    },
    async carregarTabelas(node) {
      let q = this.sistemaLicenciadaItem.bat_sql_tabelas;
      q = q.replace("{banco}", node.data?.banco);
      q = q.replace("{esquema}", node.name);
      const resultado = await this.consultaQuery(q, node);
      const array = !resultado
        ? []
        : resultado.map((item) => {
            return {
              name: item.nome_da_tabela,
              icon: "mdi-table",
              children: [],
              type: "table",
              data: {
                banco: node.data?.banco,
                esquema: node.name,
                item: item
              }
            };
          });
      node.children = array;
    },
    async carregarColunas(node) {
      let q = this.sistemaLicenciadaItem.bat_sql_colunas;
      q = q.replace("{banco}", node.data?.banco);
      q = q.replace("{esquema}", node.data?.esquema);
      q = q.replace("{tabela}", node.name);
      const resultado = await this.consultaQuery(q, node);
      const array =
        resultado.length > 0
          ? resultado.map((item) => {
              return {
                name: `${item.nome_da_coluna} (${item.tipo_de_dado})`,
                icon: "mdi-tag-outline",
                type: "column"
              };
            })
          : [
              {
                name: "Nenhuma coluna encontrada",
                icon: "mdi-alert",
                type: "column"
              }
            ];
      node.children = array;
    },
    async consultaQuery(q, node) {
      if (!q) return null;
      try {
        const responseExec = await sqlRunnerService.execQuery(
          this.sistemaLicenciadaSelecionado,
          q,
          { showOverlay: false }
        );

        if (!responseExec.data.sucesso) {
          this.error = responseExec.data.error;
          return null;
        }

        const uid = responseExec.data.uid;

        const responseResposta = await sqlRunnerService.respostaQuery(
          this.sistemaLicenciadaSelecionado,
          uid,
          { showOverlay: false }
        );

        const requisicaoData = responseResposta.data.requisicao;

        if (!requisicaoData.sucesso) {
          this.error = requisicaoData.error;
          return null;
        }
        if (requisicaoData.requisicao.status == "PENDENTE") {
          this.nodePendente = node;
          this.error =
            "A consulta ainda está sendo processada. Por favor, aguarde alguns instantes e tente novamente.";
          return null;
        }
        if (requisicaoData.requisicao.sucesso_requisicao) {
          this.nodePendente = null;
          return requisicaoData.requisicao.resultado;
        } else {
          this.error = requisicaoData.requisicao.resultado;
        }
      } catch (error) {
        this.error = error.response
          ? error.response.data.requisicao.requisicao.resultado
          : "Erro ao executar a query.";
      } finally {
        this.queryLoadingResposta = false;
      }
      this.nodePendente = null;
      return null;
    },
    resetTreeData() {
      this.treeData = [
        {
          name: "Carregar estrutura de dados",
          children: [],
          type: "start"
        }
      ];
    },
    copyColumnName(columnName) {
      this.copiarAreaTransferencia(columnName);
    }
  }
};
</script>

<style>
.turtlecat-null {
  color: #a1a5b7;
}

.turtlecat-runner,
.turtlecat-layout {
  min-height: 0;
  overflow: hidden;
}

.turtlecat-sidebar {
  flex: 0 0 auto;
  min-width: 160px;
  max-width: min(400px, calc(100% - 200px));
  overflow: auto;
}

.turtlecat-panel-hidden {
  display: none !important;
}

.turtlecat-main,
.turtlecat-workspace,
.turtlecat-results,
.turtlecat-table {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.turtlecat-code {
  flex-grow: 0;
  flex-shrink: 0;
  min-height: 0;
  overflow: hidden;
}

.turtlecat-table > .p-datatable {
  flex: 1;
  min-height: 0;
}

.turtlecat-results > :first-child {
  flex-shrink: 0;
}

.turtlecat-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #f1f3f5;
  touch-action: none;
  user-select: none;
}

.turtlecat-divider:hover,
.turtlecat-divider:focus {
  background: #c9e2ff;
  outline: none;
}

.turtlecat-divider-vertical {
  width: 8px;
  cursor: col-resize;
}

.turtlecat-divider-horizontal {
  height: 8px;
  margin-bottom: 8px;
  cursor: row-resize;
}

.turtlecat-parametros-editor .cm-gutters {
  display: none;
}

.sql-item {
  max-width: 400px; /* ajuste o valor conforme necessário */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.fa-eye {
  cursor: pointer;
  transition: all 0.3s ease; /* Aplica a transição para todas as propriedades */
}

.fa-eye:hover {
  color: #007bff; /* Muda a cor */
  transform: scale(1.1); /* Aumenta o tamanho */
}

.pui-datatable thead th:nth-child(1),
.pui-datatable tbody td:nth-child(1),
.pui-datatable tfoot td:nth-child(1) {
  width: 45px;
  max-width: 45px;
}

.p-datatable .p-frozen-column {
  background: #ffffff;
}
</style>
